import { Image } from "expo-image";
import { AHIcon, AHIconProps, useAHIconSize } from "./AHIcon";
import { Box } from "./AHTheme/Box";

export function OrgIcon({
  orgIconUri,
  size: iconSize,
  color,
  ...props
}: { orgIconUri: string | null } & Omit<AHIconProps, "type">) {
  const size = useAHIconSize(iconSize ?? "xsmall");
  if (orgIconUri) {
    return (
      <Box {...props}>
        <Image
          source={{ uri: orgIconUri }}
          cachePolicy="memory-disk"
          style={{ width: size, height: size, borderRadius: 4 }}
        />
      </Box>
    );
  }
  return <AHIcon {...props} type="org" size="xsmall" color={color} />;
}
